import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from './../services/querify.service';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
import * as i3 from "../services/querify.service";
var CompanyApi = /** @class */ (function () {
    function CompanyApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    CompanyApi.prototype.search = function (query, options) {
        var variables = this.querify.transformOptions(query, options);
        variables.orderByDistance = (options && options.orderByDistance) || null;
        return this.apollo
            .query({
            query: this.queries.companiesPaginated(),
            variables: variables,
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['companies'];
        }));
    };
    CompanyApi.prototype.searchOne = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.searchCompany(),
                        variables: { id: id }
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['company'];
                    })];
            });
        });
    };
    CompanyApi.prototype.getCompanyByConfig = function (_a) {
        var locationId = _a.locationId, segmentId = _a.segmentId, maintenanceTypeId = _a.maintenanceTypeId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.companyByConfig(),
                        variables: { locationId: locationId, maintenanceTypeId: maintenanceTypeId, segmentId: segmentId }
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['companyByConfig'];
                    })];
            });
        });
    };
    CompanyApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyApi_Factory() { return new CompanyApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: CompanyApi, providedIn: "root" });
    return CompanyApi;
}());
export { CompanyApi };
